export enum PermissiblePurposeCreateModalFields {
  permissiblePurposeReferenceId = 'permissiblePurposeReferenceId',
}

export type PermissiblePurposeCreateModalValues = {
  [PermissiblePurposeCreateModalFields.permissiblePurposeReferenceId]: string;
};
